import { x } from '@xstyled/styled-components';
import React, { useCallback, useEffect, useState } from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Card } from '~/ui/card/Card';
import { Flex } from '~/ui/flex/Flex';
import { Spinner } from '~/ui/spinner/Spinner';
import { useHelpStore } from '../Store';
import { FaqItem } from './FaqItem';
import { data } from './Faq-data';
import { useSequenceStore } from '~/training/sequence/SequenceStore';

export const Faq = () => {
  const { toggle, open } = useHelpStore();
  const [expanded, setExpanded] = useState<string>();
  const { addBlocker, removeBlocker } = useSequenceStore();

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      toggle(false);
    }
  }, []);

  useEffect(() => {
    addBlocker('nextBtn');
    return () => removeBlocker('nextBtn')
  }, [open]);

  useEffect(() => {
    document.addEventListener('keydown', escFunction);

    return () => {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  return (
    <Flex variant="center" minHeight="100%" h="auto" p="md">
      <Card p={{ _: 'md', sm: 'xl' }} w={{ _: '95%', sm: '660px' }}>
        <CloseButton onClick={() => toggle(false)} />
        <Flex variant="list" gap="md">
          <x.h2 ml="30px">{t`Frequently asked questions`}</x.h2>
          {!data ? (
            <Spinner />
          ) : (
            data?.map(({ id, title, body }) => (
              <FaqItem
                key={id}
                title={title}
                expanded={id === expanded}
                onClick={() => setExpanded(!expanded ? id : undefined)}
              >
                <x.div dangerouslySetInnerHTML={{ __html: body }}></x.div>
              </FaqItem>
            ))
          )}
        </Flex>
      </Card>
    </Flex>
  );
};
